import Typography from '@mui/material/Typography';
import { BreadCrumbsCnt } from 'pages/documents/foldersDetailView/BreadCrumbs/breadCrumbs.style';

import ArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import TemplateFolderIcon from 'components/Icons/templateFolderIcon';

function BreadCrumbs(props) {
  const { selectedFolder, setSelectedFolder } = props;
  const backToFolderHome = () => {
    setSelectedFolder(null);
  };
  const handleClickFolderLink = (id: string) => {
    // setSelectedFolder();
  };
  return (
    <BreadCrumbsCnt>
      <Typography
        variant={'h1'}
        className={'heading'}
        onClick={backToFolderHome}
      >
        Folders
      </Typography>

      {selectedFolder?.path?.map((f, index) => {
        return (
          <div
            key={index}
            className={'folderNameCnt'}
            onClick={() => handleClickFolderLink(f.id)}
          >
            <ArrowRightIcon className={'arrowIcon'} />
            <TemplateFolderIcon
              primaryColor={f?.meta?.primaryColor}
              secondaryColor={f?.meta?.secondaryColor}
            />
            <Typography variant={'h1'} className={'folderName'}>
              {f?.title}
            </Typography>
          </div>
        );
      })}
      <div className={'folderNameCnt'}>
        <ArrowRightIcon className={'arrowIcon'} />
        <TemplateFolderIcon
          primaryColor={selectedFolder?.meta?.primaryColor}
          secondaryColor={selectedFolder?.meta?.secondaryColor}
        />
        <Typography variant={'h1'} className={'folderName'}>
          {selectedFolder?.title}
        </Typography>
      </div>
    </BreadCrumbsCnt>
  );
}

export default BreadCrumbs;
